// app/javascript/controllers/working_testata_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editor", "input", "id", "results", "form"]

  connect() {
    this.items = []
    this.timeout = null
    this.abortController = null

    this.boundOutsideClick = this.outsideClick.bind(this)
    this.boundKeydown = this.keydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutsideClick)
    this.inputTarget.removeEventListener("keydown", this.boundKeydown)

    if (this.abortController) {
      this.abortController.abort()
    }

    clearTimeout(this.timeout)
  }

  edit(event) {
    event.preventDefault()

    this.displayTarget.classList.add("d-none")
    this.editorTarget.classList.remove("d-none")
    this.inputTarget.value = ""
    this.inputTarget.focus()

    this.inputTarget.addEventListener("keydown", this.boundKeydown)
    document.addEventListener("click", this.boundOutsideClick)
  }

  cancel() {
    this.closeEditor()
  }

  closeEditor() {
    this.clearResults()
    this.editorTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")

    this.inputTarget.removeEventListener("keydown", this.boundKeydown)
    document.removeEventListener("click", this.boundOutsideClick)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.performSearch(), 300)
  }

  performSearch() {
    const query = this.inputTarget.value.trim()

    this.clearResults()

    if (query.length < 2) return

    if (this.abortController) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()

    fetch(`/domains/autocomplete?query=${encodeURIComponent(query)}`, {
      signal: this.abortController.signal
    })
      .then(response => response.json())
      .then(data => {
        this.clearResults()

        data.forEach(domain => {
          const li = document.createElement("li")
          li.classList.add("list-group-item", "list-group-item-action", "py-2")
          li.innerHTML = `<strong>${domain.nome_testata || domain.dominio}</strong> <small class="text-muted">(${domain.dominio})</small>`

          li.addEventListener("click", () => this.select(domain.id))

          this.resultsTarget.appendChild(li)
          this.items.push(li)
        })

        if (this.items.length > 0) {
          this.resultsTarget.classList.remove("d-none")
        }
      })
      .catch(error => {
        if (error.name !== "AbortError") {
          console.error("Autocomplete error:", error)
        }
      })
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    }
  }

  select(domainId) {
    this.idTarget.value = domainId
    this.formTarget.requestSubmit()
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.closeEditor()
    }
  }

  clearResults() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("d-none")
    this.items = []
  }
}
